import React, { useEffect, useState } from 'react';
import { trackClick } from 'js/utils/trackClick';
import {
  recordShow,
  recordDismissal,
  recordClickthrough,
} from 'js/utils/dismissibles';
import routes from 'sitewide-js/core_pre_webpack/routes';

import { CommonUnibrow } from './common';

type Props = {
  offer: 'price' | 'discount';
  value: string;
  mentions?: number;
};

export default function ChurnedUserReactivationUnibrow({
  offer,
  value,
  mentions,
}: Props) {
  const [show, setShow] = useState(true);

  const nagName = 'ChurnedUserReactivationUnibrow';

  useEffect(() => {
    recordShow(nagName);
  }, []);

  const clickThrough = () => {
    recordClickthrough(nagName);
    trackClick({
      source: 'churned_user_reactivation_unibrow',
      extra: {},
    });
    window.location.href = routes.checkout_path({
      feature: 'churned_user_reactivation',
      trigger: 'reactivate_unibrow',
    });
  };

  const hide = () => {
    recordDismissal(nagName);
    setShow(false);
  };

  if (!show) return null;

  let ctaText;
  let buttonText;
  if (offer === 'discount') {
    ctaText = mentions
      ? `See your ${mentions} new Mentions, ${value} OFF Premium`
      : `Accelerate your research, ${value} OFF Premium`;
    buttonText = `Reactivate Premium, ${value} OFF ▸`;
  } else {
    ctaText = mentions
      ? `See your ${mentions} new Mentions for just ${value}`
      : `Accelerate your research with Premium for just ${value}`;
    buttonText = `Reactivate Premium for ${value} ▸`;
  }

  return (
    <CommonUnibrow
      ctaText={ctaText}
      buttonText={buttonText}
      clickThrough={clickThrough}
      hide={hide}
    />
  );
}
